export default __webpack_public_path__ + "static/lePantalon.logo-7f83fdb8a1d5d06a5ab6ed9b046df235.png";